export const removeDecimals = (value: string | number | null | undefined) => {
  if ((typeof value === 'string' && Boolean(value.trim())) || typeof value === 'number') {
    return Math.round(Number(value))
  }

  return ''
}

export const round = (num: number, decimals: number): number => {
  const rounder = 10 ** decimals
  const m = Number((Math.abs(num) * rounder).toPrecision(15))
  return (Math.round(m) / rounder) * Math.sign(num)
}

export const roundUp = (num: number, decimals: number): number => {
  const rounder = 10 ** decimals
  const m = Number((Math.abs(num) * rounder).toPrecision(15))
  return (Math.ceil(m) / rounder) * Math.sign(num)
}
